import { createSlice } from "@reduxjs/toolkit";
import { checkEmpty } from "../../utils/helper";
import { getStorageJSON, setStorageJSON } from "../../utils";

const baseState = {
  dispatch: { summary: false, changing: false, disp: true },
  basicDetails: { summary: false, changing: false, disp: false },
  verifyOtp: { changing: false, disp: false },
  addressDetails: {
    summary: false,
    changing: false,
    addnew: false,
    disp: false,
  },
  payment: { summary: false, changing: false, disp: false },
  basketId: 0,
};

// 🔧 Helper: build FULL state for a given step
const buildCheckoutStepState = (step, basketId = 0) => {
  // start from a fresh copy of baseState
  const state = JSON.parse(JSON.stringify(baseState));
  state.basketId = basketId;

  switch (step) {
    case "dispatch":
      // baseState already matches dispatch step
      break;

    case "basicDetails":
      state.dispatch = {
        summary: true,
        changing: false,
        disp: false,
      };
      state.basicDetails = {
        summary: false,
        changing: false,
        disp: true,
      };
      // others remain default (hidden)
      break;

    case "basicinfo":
      state.dispatch = {
        summary: true,
        changing: false,
        disp: false,
      };
      state.basicDetails = {
        summary: false,
        changing: false,
        disp: true,
      };
      // others remain default (hidden)
      break;

      case "verifyOtp":
      state.dispatch = {
        summary: true,
        changing: false,
        disp: false,
      };
      state.basicDetails = {
        summary: false,
        changing: false,
        disp: true,
      };
      state.verifyOtp = {
        changing: false,
        disp: true,
      };
      break;

    case "addressDetails":
      state.dispatch = {
        summary: true,
        changing: false,
        disp: false,
      };
      state.basicDetails = {
        summary: true,
        changing: false,
        disp: true,
      };
      state.addressDetails = {
        summary: false,
        changing: false,
        addnew: false,
        disp: true,
      };
      break;

    case "payment":
      state.dispatch = {
        summary: true,
        changing: false,
        disp: false,
      };
      state.basicDetails = {
        summary: true,
        changing: false,
        disp: false,
      };
      state.addressDetails = {
        summary: true,
        changing: false,
        addnew: false,
        disp: false,
      };
      state.payment = {
        summary: false,
        changing: false,
        disp: true,
      };
      break;

    default:
      // unknown step -> fallback to base
      break;
  }

  return state;
};

const kuickCheckoutStep = getStorageJSON("kuick-checkout-step");

const initialState = !checkEmpty(kuickCheckoutStep)
  ? kuickCheckoutStep
  : baseState;

const checkoutStep = createSlice({
  name: "checkoutStep",
  initialState,
  reducers: {
    // Replace full state and persist (payload should be a full state object)
    storageCheckoutStep(state, action) {
      const newState = action.payload;
      setStorageJSON("kuick-checkout-step", newState);
      return newState;
    },

    // Build full step state from helper and persist it
    resetCheckoutStep(state, action) {
      const { step, basketId } = action.payload || {};
      const newState = buildCheckoutStepState(step, basketId);

      setStorageJSON("kuick-checkout-step", newState);
      return newState; // important: return to replace Immer draft
    },
  },
});

export const checkoutReduce = checkoutStep.reducer;
export const { resetCheckoutStep, storageCheckoutStep } = checkoutStep.actions;
